<template>
  <div>
    <div v-if="!readOnly" class="ml-2 mr-2 mb-2 mt-2">
      <label>{{ $t('operacoes') }} </label>
      <b-form-select
        class="input-pentagro"
        v-model="operationSelected"
        :options="operations"
      ></b-form-select>
    </div>
    <div v-if="operationSelected" class="b-layout">
      <div class="inp">
        <label>{{ $t('temperatura-na-saida-c') }} </label>
        <input v-model="TSaida.value" min="0" step="0.01" type="number" />
      </div>
    </div>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      attrList: ["TSaida"],
      TSaida: {},
      operations: [{ value: null, text:this.$t('selecione-uma-operacao') }],
      operationSelected: null,
      operationAttributeList: [],
      firstLoad: false,
    };
  },

  watch: {
    operationSelected(value) {
      if (this.firstLoad || !value) {
        this.firstLoad = false;
        return;
      }
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));

      this.TSaida = this.operationAttributeList.find(
        (p) => this.attrList[0] == p.caption
      );
      if (this.TSaida) this.TSaida.value = ParseToNumber(this.TSaida.value);
      this.updateNode();
    },

    "TSaida.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.operationSelected = this.node.data[0].index;
        this.firstLoad = true;
      }

      this.node.data.forEach((p) => {
        this.attrList.forEach((a) => {
          if (p.caption == a) {
            p.value = ParseToNumber(p.value);
            this[a] = p;
          }
        });
      });
    },

    updateNode() {
      this.node.attrs = [this.TSaida.clone()];
    },

    loadOperation() {
      let optList = SingletonEnginnering.operations.filter((o) =>
        o.match(/EDA/)
      );
      this.operations.splice(1);
      optList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

input {
  margin-left: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>